var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceUnknownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 32,
    height: 30,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fillRule:evenodd;clip-rule:evenodd;fill:#D0D0D0;}\n\t.st1{fillRule:evenodd;clip-rule:evenodd;fill:#1D1D1D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.63,418.91h232.73V93.08H139.63V418.91z M279.27,395.63h-46.55v-46.55h46.55V395.63z M256,133.13 c45.61,0,81.46,35.14,81.46,80.75c0,52.59-60.98,57.96-60.98,103.57h-40.96c0-67.02,61.21-62.84,61.21-103.57 c0-21.64-19.09-40.73-40.73-40.73s-40.73,19.09-40.73,40.73h-40.73C174.54,168.49,210.39,133.13,256,133.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.73,349.09h46.55v46.55h-46.55V349.09z M372.37,0H139.63c-25.61,0-46.55,20.94-46.55,46.54v418.92 c0,25.61,20.93,46.55,46.55,46.55h232.73c25.59,0,46.55-20.93,46.55-46.55V46.54C418.91,20.94,397.96,0,372.37,0z M372.37,418.91 H139.63V93.08h232.73V418.91z M256,173.15c21.64,0,40.73,19.09,40.73,40.73c0,40.73-61.21,36.55-61.21,103.57h40.96 c0-45.61,60.98-50.98,60.98-103.57c0-45.61-35.84-80.75-81.46-80.75s-81.46,35.36-81.46,80.75h40.73 C215.27,192.24,234.36,173.15,256,173.15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceUnknownIcon);
export default __webpack_public_path__ + "static/media/device-unknown-icon.9d9f4c829f6e8f396f3d13ac5e205fb2.svg";
export { ForwardRef as ReactComponent };